








































































import { Vue, Component } from "vue-property-decorator";
import btripServcice from "@/service/btripServcice";
import { NavBar, Icon, Button,List, PullRefresh } from "vant";

@Component({
  name: "btrpHomePage",
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },
})
export default class extends Vue {
  searchValue = "";
  isDropDownlLoading = false;
  isPullUploading = false;
  finished = false;
  TaskForm: any[] = [];
  queryModel = {
    PageNo: 0,
    PageSize: 5,
    TaskName: "",
    TaskID: "",
  };
  created() {}
  actived() {
    this.obtain();
    this.getTasklist();
  }
  onLoad() {
    console.log("进行了上拉加载");
    this.queryModel.PageNo++;
    btripServcice.getTasklist(this.queryModel).then((json: any) => {
      if (json.isSucc) {
        if (json.result.entities.length !== 0) {
          for (let i = 0; i < json.result.entities.length; i++) {
            this.TaskForm.push(json.result.entities[i]);
          }
          this.isPullUploading = false;
        } else {
          this.finished = true;
        }
      }
    });
  }
  onRefresh() {
    console.log("下拉刷新");
    this.ReastModel();
    btripServcice.getTasklist(this.queryModel).then((json: any) => {
      if (json.isSucc) {
        this.TaskForm = json.result.entities;
        this.isDropDownlLoading = false;
      }
    });
  }
  JumpForm() {
    this.$router.push("/btrip/applicationForm");
  }
  JumpList() {
    this.$router.push("/btrip/applicationList");
  }
  query = {
    TaskName: "",
    TaskID: "",
  };
  formatDate(value: Date, format: string = "YYYY-MM-DD") {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  obtain() {
    this.query.TaskName = String(this.profile.UserName);
  }
  getTasklist() {
    btripServcice.getTasklist(this.query).then((json: any) => {
      if (json.isSucc) {
        this.TaskForm = json.result.entities;
      }
    });
  }
  ReastModel() {
    (this.queryModel.PageNo = 1), (this.queryModel.PageSize = 5), (this.queryModel.TaskName = ""), (this.queryModel.TaskID = "");
  }
  CardDetails(item: any) {
    this.$router.push({
      name: "cardModify",
      params: {
        item: item,
      },
    });
  }
  // S00008563895
  automaticSearch() {
    console.log("输入了");
    console.log("value", this.searchValue);
    if (/\S/.test(this.searchValue)) {
      if (/^S\d{11}$/.test(this.searchValue)) {
        this.query.TaskID = this.searchValue;
        console.log(this.query);
        this.getTasklist();
      } else {
        console.log("申请单号错误");
        this.$notify({ type: "warning", message: "请输入正确的单号" });
      }
    } else {
      this.obtain();
      this.query.TaskID = "";
      this.getTasklist();
    }
  }
  search() {
    console.log("查询");

    this.obtain();
    this.query.TaskID = this.searchValue;
    this.getTasklist();
  }
}
